import React, { useState } from "react";
import { Modal, Stack, Button, Group, Text, Divider } from "@mantine/core";
import { IconSend, IconFileCheck, IconSignature } from "@tabler/icons-react";

function ManageDocumentsModal({ isOpen, onClose, recruit, onAction }) {
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSendViaESignature = async () => {
    setIsProcessing(true);
    try {
      await onAction("sendESignature", recruit);
      onClose();
    } finally {
      setIsProcessing(false);
    }
  };

  const handleMarkDocsSent = async () => {
    setIsProcessing(true);
    try {
      await onAction("markDocsSent", recruit);
      onClose();
    } finally {
      setIsProcessing(false);
    }
  };

  const handleMarkSigned = async () => {
    setIsProcessing(true);
    try {
      await onAction("markSigned", recruit);
      onClose();
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <Modal
      opened={isOpen}
      onClose={onClose}
      title={
        <Text fw={600} size="lg">
          Manage Documents - {recruit?.name}
        </Text>
      }
      size="md"
      centered
    >
      <Stack gap="md">
        <Text c="dimmed" size="sm">
          Choose how you want to manage documents for this recruit:
        </Text>

        <Divider />

        {/* Send via eSignature */}
        <Button
          variant="light"
          color="blue"
          size="md"
          leftSection={<IconSend size={20} />}
          onClick={handleSendViaESignature}
          disabled={isProcessing}
          fullWidth
          styles={{
            root: {
              height: "auto",
              padding: "16px",
            },
            inner: {
              justifyContent: "flex-start",
            },
            section: {
              marginRight: "12px",
            },
          }}
        >
          <Stack gap={4} align="flex-start">
            <Text fw={600} size="sm">
              Send via eSignature
            </Text>
            <Text size="xs" c="dimmed" fw={400}>
              Send documents electronically for signing
            </Text>
          </Stack>
        </Button>

        {/* Manually mark as Docs Sent */}
        <Button
          variant="light"
          color="orange"
          size="md"
          leftSection={<IconFileCheck size={20} />}
          onClick={handleMarkDocsSent}
          disabled={isProcessing}
          fullWidth
          styles={{
            root: {
              height: "auto",
              padding: "16px",
            },
            inner: {
              justifyContent: "flex-start",
            },
            section: {
              marginRight: "12px",
            },
          }}
        >
          <Stack gap={4} align="flex-start">
            <Text fw={600} size="sm">
              Mark as Docs Sent
            </Text>
            <Text size="xs" c="dimmed" fw={400}>
              Manually mark that documents have been sent
            </Text>
          </Stack>
        </Button>

        {/* Manually mark as Signed */}
        <Button
          variant="light"
          color="green"
          size="md"
          leftSection={<IconSignature size={20} />}
          onClick={handleMarkSigned}
          disabled={isProcessing}
          fullWidth
          styles={{
            root: {
              height: "auto",
              padding: "16px",
            },
            inner: {
              justifyContent: "flex-start",
            },
            section: {
              marginRight: "12px",
            },
          }}
        >
          <Stack gap={4} align="flex-start">
            <Text fw={600} size="sm">
              Mark as Signed
            </Text>
            <Text size="xs" c="dimmed" fw={400}>
              Manually mark that documents have been signed
            </Text>
          </Stack>
        </Button>

        <Divider />

        <Group justify="flex-end">
          <Button variant="subtle" onClick={onClose} disabled={isProcessing}>
            Cancel
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}

export default ManageDocumentsModal;
